const initialState = () => ({
  widgets: []
})

export default initialState
